import React, { useEffect, useState, useRef,useContext } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import DeleteIcon from '@assets/icons/deleteIcon';
import OpenInEditorIcon from '@assets/icons/openInEditorIcon';
import DuplicateAndEditIcon from '@assets/icons/duplicateAndEditIcon';
import FavoriteIcon from '@assets/icons/favoriteIcon';
import UnfavoriteIcon from '@assets/icons/unfavoriteIcon';
import PlusIcon from '@assets/icons/plusIcon';
import SaveTemplateIcon from '@assets/icons/saveTemplateIcon';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';
import { isatty } from 'tty';
import CreateACopyIcon from '@assets/icons/createACopyIcon';
import FullPreviewIcon from '@assets/icons/fullPreviewIcon';
import { useSelector, useDispatch } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { getUserPermission } from '@utils/design';
import { StudioContext } from '@utils/DOIgnition/StudioContext';
import { IDesignAuth } from '@state/designs/types';
import { IUserType } from '@state/auth/types';
import { useLocation } from "react-router-dom";

const PreviewComponentOptions:React.FC<IProps> = (props) => {
  const [totalOffSetTop, setTotalOffSetTop]=useState(0);
  const [favorite, setFavorite] = useState(props.design.favorite);
  const [showEditOptions, setShowEditOptions] = useState<boolean|undefined>(undefined);
  const [validating, setValidating] = useState<boolean>(true);
  const authContext = useContext(AuthContext);
  const studioContext = useContext(StudioContext);
  const designsContext = useContext(DesignsContext);
  const isAdmin = authContext.userData && authContext.userData.profile && authContext.userData.profile.role === IUserType.ADMIN;
  const designAuth = useSelector(selectors.designs.getDesignAuth);
  const dispatch = useDispatch();

  const getDesignAuth = (id: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.getDesignAuth(id, (result, error) => {
        if (error) reject(error);
        else resolve(result);
      }))
    });
  }

  useEffect(() => {
    const asyncUseEfect = async () => {
      try {
        if (props.design && props.design.entityType === "DESIGN" && studioContext?.value==="SHARED") {
          let responseDesignAuth = await getDesignAuth(props.design.id);
          if (responseDesignAuth)setShowEditOptions(getUserPermission(props.design?.createdBy, authContext.userData?.profile, responseDesignAuth as IDesignAuth, authContext.loggedToken)===1)
        } else {
          if (designsContext?.sharedFiles?.open ) setShowEditOptions(designsContext?.sharedFiles?.permission===1);
          else setShowEditOptions(true);
        }
        setValidating(false);
      } catch(e) {
        console.error(e);
      }
    }
    asyncUseEfect();
  }, [props.design])

  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          props.setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const optionsRef = useRef(null);
  useOutsideAlerter(optionsRef);

  useEffect(() => {
    if(optionsRef && optionsRef.current){
      let element: any = optionsRef.current
      if (location.pathname==="/my-designs") {
        let offsetTop = 0;
        while (element && !(element.id as string).startsWith("preview-component-")) {
          element = element.parentElement;
        }
        if (element && element.offsetTop) {
          offsetTop = element.offsetTop;
        }
        setTotalOffSetTop(offsetTop);
      }
      if (location.pathname==="/shared-files") {
        let offsetTop = 0;
        while (element && !(element.id as string).startsWith("preview-component-")) {
          element = element.parentElement;
        }
        if (element && element.offsetTop) {
          offsetTop = element.offsetTop;
        }
        setTotalOffSetTop(offsetTop);
      }
    }
  }, [optionsRef]);

  const handleOpenInEditor = () => {
    openEditor();
    props.setOpen(false);
  }

  const handleDuplicateAndEdit = () => {
    props.onActions("DUPLICATEEDIT");
    props.setOpen(false);
  }

  const handleFavorite = () =>{
    props.onActions("FAVORITEDESIGN");
    props.setOpen(false);
  }

  const handleNameFolder = () => {
    props.onActions("NAMEFOLDER");
  }

  const handleSaveAsTemplate = () => {
    props.onActions("SAVEASTEMPLATE");
  }

  const handleDelete = () => {
    props.onActions("DELETE");
    props.setOpen(false);
  }

  let location = useLocation();

  const returnLeftValue = () => {
    var value = props.coordinates.x;
    if (location.pathname==="/studio") {
      if (props.coordinates.x > 1000) {
        value -= 785;
      }
      else {
        value -= 440;
      }
    }
    if (location.pathname==="/my-designs") {
      if (props.coordinates.x > 1300) {
        value -= 1085;
      }
      else {
        value -= 740;
      }
    }
    if (location.pathname==="/shared-files") {
      if (props.coordinates.x > 1300) {
        value -= 1085;
      }
      else {
        value -= 740;
      }
    }
    return value;
  }

  const returnTopValue = () => {
    var value = 0;
    if (location.pathname==="/studio") {
      value = -150;
    }
    if (location.pathname==="/my-designs") {
      value = totalOffSetTop - 160;
      if (props.coordinates.y < 500) {
        value += 145;
      }
    }
    if (location.pathname==="/shared-files") {
      value = totalOffSetTop - 160;
      if (props.coordinates.y < 500) {
        value += 145;
      }
    }
    return value;
  }

  const openEditor = () => {
    window.open(`/editor/design/${props.design.id}`);
  }

  const handleViewPreview=()=>{
    props.onActions("PREVIEW");
    props.setOpen(false);
  }

  const showFavorite = studioContext?.value!=="SHARED" && !designsContext?.sharedFiles?.open;
  const showEditName = studioContext?.value!=="SHARED" && !designsContext?.sharedFiles?.open;

  return (
    <S.Root 
      ref={optionsRef}
      leftValue={`${returnLeftValue()}px`}
      topValue={`${returnTopValue()}px`}
    >
      {(props.open && !validating) &&
        <S.PopupContainer>
          <S.Title>
            {props.labels.name}
          </S.Title>
          <S.DescriptionContainer>
            <S.Description>
              {props.labels.designType}
            </S.Description>
            <S.Description>
              {`Created: ${props.labels.createdDate} by ${props.labels.userName}`}
            </S.Description>
            <S.Description>
              {`Last Edited: ${props.labels.lastEditedDate}`}
            </S.Description>
          </S.DescriptionContainer>
          <S.TopOptionsContainer>
            {
              props.design.entityType==="DESIGN" &&
              <>
              <S.OptionContainer
                onClick={handleOpenInEditor}
              >
                <S.OptionIconContainer>
                  <OpenInEditorIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Open in Editor`}
                </S.OptionText>
              </S.OptionContainer>
              <S.OptionContainer
                onClick={handleDuplicateAndEdit}
              >
                <S.OptionIconContainer>
                  <CreateACopyIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Create a Copy & Edit`}
                </S.OptionText>
              </S.OptionContainer>

              {showFavorite &&
              <S.OptionContainer
                onClick={handleFavorite}
              >
                <S.OptionIconContainer>
                  {favorite ? <UnfavoriteIcon/> : <FavoriteIcon/>}
                </S.OptionIconContainer>
                <S.OptionText>
                  {favorite ? `Remove from Favorites` : `Add to Favorites`}
                </S.OptionText>
              </S.OptionContainer>}

              {showEditName && 
              <S.OptionContainer
                onClick={handleNameFolder}
              >
                <S.OptionIconContainer>
                  <PlusIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Edit Name and Add to Folder`}
                </S.OptionText>
              </S.OptionContainer>}
              </>
            }
            {
              isAdmin && props.design.entityType==="DESIGN" && showEditOptions &&
              <S.OptionContainer
              onClick={handleSaveAsTemplate}
              >
                <S.OptionIconContainer>
                  <SaveTemplateIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Save as Template`}
                </S.OptionText>
              </S.OptionContainer>
            }
            {showEditOptions &&
              <S.OptionContainer
              onClick={handleViewPreview}
              >
                <S.OptionIconContainer>
                  <FullPreviewIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`View Preview`}
                </S.OptionText>
              </S.OptionContainer>
            }
          </S.TopOptionsContainer>
          {
              props.design.entityType==="DESIGN" && showEditOptions &&
              <>
          <S.Divider />
          <S.BottomOptionsContainer>
            
            <S.OptionContainer
              onClick={handleDelete}
            >
              <S.OptionIconContainer>
                <DeleteIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Delete Design`}
              </S.OptionText>
            </S.OptionContainer>
          
          </S.BottomOptionsContainer>
          </>
          }
        </S.PopupContainer>
      }
    </S.Root>
  );
}

export default PreviewComponentOptions;